module.exports = __webpack_public_path__ + "static/media/star-o.4e52728d.svg";